// Label de shadcn sobre la primitiva de Radix. Radix y no un <label> pelado
// para que el click tambien enfoque cuando el control deja de ser un input
// nativo (un select o un combobox de la nomina, PP-22), sin tener que
// reescribir el formulario ahi.
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "./cn.js";

export function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>): React.JSX.Element {
  return (
    <LabelPrimitive.Root
      className={cn("font-sans text-sm font-medium text-texto-2", className)}
      {...props}
    />
  );
}
